import React from 'react'

export enum CardViewLayout {
    COLOR_CODING_BORDER_LEFT    = 'left',
    COLOR_CODING_BORDER_TOP     = 'top',
    COLOR_CODING_NONE           = 'none',
    COLOR_CODING_FILL           = 'fill',
}

const defaultOptions = [{
    value   : CardViewLayout.COLOR_CODING_BORDER_LEFT,
    img     : '/app/web/skin/common/svg/board-color-coding/left.svg'
}, {
    value   : CardViewLayout.COLOR_CODING_BORDER_TOP,
    img     : '/app/web/skin/common/svg/board-color-coding/top.svg'
}, {
    value   : CardViewLayout.COLOR_CODING_FILL,
    img     : '/app/web/skin/common/svg/board-color-coding/fill.svg'
},{
    value   : CardViewLayout.COLOR_CODING_NONE,
    img     : '/app/web/skin/common/svg/board-color-coding/none.svg'
}]

type Option = {
    value   : string,
    img     : string,
}

type Props = {
    value       : any,
    options     : any[],
    disabled?   : boolean,

    onChange    : any
}

export default function CardViewSelector(props: Props) {

    const onClick = (option: Option) => {
        if (props.disabled) return
        props.onChange(option)
    }

    const options = _.get(props, 'options', defaultOptions)

    return (
        <div className="ui5-card-view-selector">
            { _.map(options, (option, key)=>{
                const classes = Classes('card', {
                    selected: props.value === option.value
                })

                const style = {
                    backgroundImage : 'url('+option.img+')'
                }

                return (
                    <div key={key} className={classes} onClick={()=>{onClick(option)}}>
                        <div className="preview" style={style}/>
                        {(props.value === option.value) &&
                            <div className="ui5-ico-selected s-15"/>}
                    </div>
                )
            })}
        </div>
    )
}